import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../ProviderAuth/AuthProvider'
import {Navbar, NavbarBrand, NavbarMenuToggle, NavbarMenu, NavbarMenuItem, NavbarContent, NavbarItem, Link, Button} from "@heroui/react";
import { getAuth } from 'firebase/auth';
import { app, db } from '../../Firebase/firebase';
import LOGO from "../Fotos/LOGO.png"
import { NavLink } from 'react-router-dom';
import { doc, setDoc, updateDoc } from 'firebase/firestore';
import { generarId } from '../Helpers/generarId';
const NavBarPublico = () => {
  const [menuisActive,setMenuIsActive]=useState(false) 
    const [auth]=useContext(AuthContext)
    const menuItems = [
        "Clientes",
        "Configuraciones",
    ];

    const handleCerrarSesion=()=>{
        const auth=getAuth(app)
        auth.signOut()
    }

    useEffect(()=>{
      if (auth?.user?.uid){
        setDoc(doc(db,"registroDeEntradas",auth.user.uid),{[generarId()]:new Date()},{merge:true})
      }
    },[auth.user])

  return (
    <>
    {!auth.user&&
            <Navbar className='from-gray-900 to-sky-900 bg-gradient-to-t text-white' disableAnimation isBordered isBlurred shouldHideOnScroll onMenuOpenChange={(e)=>setMenuIsActive(e)} isMenuOpen={menuisActive}>
            <NavbarContent className="sm:hidden" justify="start">
              <NavbarMenuToggle />
            </NavbarContent>
      
            <NavbarContent className="sm:hidden pr-3" justify="center">
              <NavbarBrand className=' w-28'>
                {/*<img src={LOGO}/>*/}
              </NavbarBrand>
            </NavbarContent>
      
            <NavbarContent className="hidden sm:flex gap-4 divide-x divide-gray-100" justify="center">
              <NavbarBrand className=" w-28 ">
                {/*<img className="" src={LOGO}/>*/}
              </NavbarBrand>
              <NavbarItem className='px-2'>
                <NavLink color="foreground" exact to="/prestamos/informacion">
                  <div className='flex flex-col items-center'>
                    <label className=' font-semibold'>Inicio</label>
                  </div>
                </NavLink>
              </NavbarItem>
              <NavbarItem className='px-2'>
                <NavLink color="foreground" exact to="/bancas/resumen">
                  <div className='flex flex-col items-center'>
                    <label className='font-semibold'>Comprar boletos</label>
                  </div>
                </NavLink>
              </NavbarItem>
            </NavbarContent>
      
            <NavbarMenu>
                
                <NavbarItem
                  onClick={()=>setMenuIsActive(false)}
                >
                  <NavLink color="foreground" exact to="/prestamos/informacion">
                    <div className='flex items-center gap-4'>
                      <i className="fa-solid fa-building-user text-xl"></i>
                      <label >Inicio</label>
                    </div>
                  </NavLink>
                </NavbarItem>
                <NavbarMenuItem
                  onClick={()=>setMenuIsActive(false)}
                >
                  <NavLink color="foreground" exact to="/bancas/resumen">
                    <div className='flex items-center gap-4'>
                      <i className="fa-solid fa-vault text-xl"></i>
                      <label className=''>Comprar Boletos</label>
                    </div>
                  </NavLink>  
                </NavbarMenuItem>
            </NavbarMenu>
          </Navbar>
    }
    </>
  )
}

export default NavBarPublico